import isEqual from "fast-deep-equal/es6";
import { create } from "zustand";
import { GPS } from "../../util/geo";
import { config } from "./config";
import { Cube } from "./types";
import { FetchState, ignore } from "./util";

interface SelectionState {
  state?: FetchState;
  error?: any;
  gps?: GPS;
  cube?: Cube;
  selectGPS: (gps: GPS) => void;
  clear: () => void;
}

interface HeightState {
  state?: FetchState;
  error?: any;
  gps?: GPS;
  data?: {
    url: string;
    extent: number[];
    stats: {
      min: number;
      max: number;
      mean: number;
      histogram: [number[], number[]];
    };
    versions: any[];
    version?: number;
  };
  selectHeight: (gps: GPS, version?: number) => void;
  clear: () => void;
}

async function fetchState(url, gps, get, set, datakey) {
  if (isEqual(gps, get().gps)) return;
  set({ gps, state: "fetching", error: undefined });
  const response: Response = await fetch(url).catch(ignore);
  if (!response.ok) return set({ gps, state: "error", error: response.status });
  const data = await response.json();
  if (get().gps === gps) {
    // not changed in the meantime, update state
    set({ state: "fetched", [datakey]: data });
  }
}

export const useSelection = create<SelectionState>((set, get) => ({
  selectGPS: async (gps: GPS) => {
    await fetchState(
      `${config.referenceUrl}/api/cube?c=${gps[0]},${gps[1]}`,
      gps,
      get,
      set,
      "cube"
    );
  },
  clear: async () => set({ state: undefined, cube: undefined }),
}));

export const useHeightData = create<HeightState>((set, get) => ({
  selectHeight: async (gps: GPS, version?: number) => {
    const p = version !== undefined ? `&version=${version}` : "";
    await fetchState(
      `${config.referenceUrl}/api/image/height?c=${gps[0]},${gps[1]}${p}`,
      gps,
      get,
      set,
      "data"
    );
  },
  clear: async () => set({ state: undefined, gps: undefined, data: undefined, error: undefined }),
}));
